module.exports = __webpack_public_path__ + "static/assets/1e44d6a3007d92f7db748c5f3f6a33b1.svg";